import { Grid } from "semantic-ui-react";

import ValidatedForm from "components/forms/ValidatedForm";
import { type NumberRangeFilterValues } from "utils/filterUtils";
import { type EnrollmentRule } from "../AutomaticallyDetect/models";
import { ErrorPositions } from "enums/errorPositions";

export interface RangePickerProps {
  itemIndex: number;
  onIsValidChange?: (isValid: boolean) => void;
  items: EnrollmentRule[];
  validatedFieldProps: any;
  disabled: boolean;
  rowModelName: string;
  handleChange: (index: number) => void;
}

export const NumberRangePicker = ({
  itemIndex,
  onIsValidChange,
  items,
  validatedFieldProps,
  disabled,
  rowModelName,
  handleChange: handleRuleChange,
}: RangePickerProps) => {
  return (
    <Grid>
      <Grid.Column>
        <ValidatedForm.InputField
          placeholder="Enter&nbsp;Days"
          search
          selected={(items[itemIndex].value as NumberRangeFilterValues).start || ""}
          value={(items[itemIndex].value as NumberRangeFilterValues).start || ""}
          propertyName={`${rowModelName}.value.start`}
          markAsRequired
          allowAdditions
          disabled={disabled || items[itemIndex].filter === null}
          onIsFormValidChange={onIsValidChange}
          onBlur={() => handleRuleChange(itemIndex)}
          onDateChange={() => handleRuleChange(itemIndex)}
          onChangeCallback={() => handleRuleChange(itemIndex)}
          handleFieldChange={() => handleRuleChange(itemIndex)}
          errorPosition={ErrorPositions.bottom}
          {...validatedFieldProps}
        />
      </Grid.Column>
      <Grid.Column>
        <span className="delimiter">-</span>
      </Grid.Column>
      <Grid.Column>
        <ValidatedForm.InputField
          placeholder="Enter&nbsp;Days"
          search
          selected={(items[itemIndex].value as NumberRangeFilterValues).finish || ""}
          value={(items[itemIndex].value as NumberRangeFilterValues).finish || ""}
          propertyName={`${rowModelName}.value.finish`}
          markAsRequired
          allowAdditions
          disabled={disabled || items[itemIndex].filter === null}
          onIsFormValidChange={onIsValidChange}
          onBlur={() => handleRuleChange(itemIndex)}
          onDateChange={() => handleRuleChange(itemIndex)}
          onChangeCallback={() => handleRuleChange(itemIndex)}
          handleFieldChange={() => handleRuleChange(itemIndex)}
          errorPosition={ErrorPositions.bottom}
          {...validatedFieldProps}
        />
      </Grid.Column>
    </Grid>
  );
};
